import { yupResolver } from '@hookform/resolvers/yup';
import { useNotifications } from '@toolpad/core';
import { useForm } from 'react-hook-form';
import {
    PasswordElement,
    SwitchElement,
    TextFieldElement,
} from 'react-hook-form-mui';
import { useLocation, useNavigate } from 'react-router';
import * as Yup from 'yup';
import { Stack } from '@mui/material';

import { useAuth } from '@barboxx/admin-utils';
import { Authentication } from '@barboxx/models';

import { StyledForm, SubmitButton } from '../StyledComponents';

const LOGIN_SCHEMA = Yup.object().shape({
    email: Yup.string().email('Must be an email address').required('Required'),
    password: Yup.string().required('Required'),
});

export function LoginForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const notifications = useNotifications();
    const { login, persist } = useAuth();

    const formContext = useForm<Authentication.UserLoginRequest>({
        resolver: yupResolver(LOGIN_SCHEMA),
        defaultValues: persist,
    });

    const from = location.state?.from?.pathname ?? '/';

    const onSubmit = (values: Authentication.UserLoginRequest) =>
        login(values)
            .then(({ user }) => {
                navigate(from, { replace: true });
            })
            .catch((error: Error) => {
                notifications.show(error.message, {
                    severity: 'error',
                });
            });

    return (
        <StyledForm onSuccess={onSubmit} formContext={formContext}>
            <Stack gap={2}>
                <TextFieldElement
                    label="Email"
                    name="email"
                    fullWidth
                    required
                    autoComplete="email"
                    autoFocus
                />
                <PasswordElement
                    label="Password"
                    name="password"
                    type="password"
                    fullWidth
                    required
                    autoComplete="current-password"
                />
                <SwitchElement
                    label="Remember Me"
                    name="rememberMe"
                    color="primary"
                    labelPlacement="start"
                    sx={{
                        justifyContent: 'space-between',
                    }}
                />
                <SubmitButton
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    loading={formContext.formState.isSubmitting}
                    disabled={!formContext.formState.isDirty}
                >
                    Login
                </SubmitButton>
            </Stack>
        </StyledForm>
    );
}
